import React from 'react';
import Hero from '../Hero';
import Spacing from '../Spacing';
import FunFact from '../FunFact';
import About from '../About';
import WhyChose from '../WhyChose';
import Service from '../Service';
import Portfolio from '../Portfolio';
import Button from '../Button';
import SectionHeading from '../SectionHeading';
import Award from '../Award';
import Accordion from '../Accordion';
import Cta from '../Cta';
import TestimonialSlider from '../Slider/TestimonialSlider';
import PostCarousel from '../Slider/PostCarousel';
import { pageTitle } from '../../helpers/PageTitle';
const funfactData = [
  { title: 'Active Projects', number: '50+' },
  { title: 'Solutions Delivered', number: '100+' },
  { title: 'Expert Team Members', number: '25+' },
  { title: 'Countries Served', number: '10+' },
];
const whyChoseFeatureData = [
  {
    title: 'Multi-disciplinary Expert Team',
    content:
      'Our team combines deep expertise across software development, cloud architecture, AI/ML, and DevOps. We bring diverse technical skills and industry experience to deliver comprehensive technology solutions.',
  },
  {
    title: 'Cutting-edge Technology Stack',
    content:
      'We leverage the latest technologies and best practices in web, mobile, and cloud development. Our solutions are built for scalability, security, and optimal performance using modern frameworks and tools.',
  },
  {
    title: 'Proven Delivery Methodology',
    content:
      'From research and ideation to deployment and maintenance, our systematic approach ensures projects are delivered on time and exceed expectations. We prioritize quality, testing, and continuous improvement.',
  },
];
const serviceListData = [
  {
    title: 'Custom Software Development',
    subtitle:
      'Building tailored web, mobile, and cloud applications that solve real business challenges. From concept to deployment, we create scalable, secure, and user-friendly software solutions.',
    imgUrl: '/images/creative-agency/service_7.jpeg',
    href: '/service/service-details',
  },
  {
    title: 'Cloud & DevOps Solutions',
    subtitle:
      'Comprehensive cloud infrastructure, DevOps automation, CI/CD pipelines, and managed services. We ensure your systems are reliable, scalable, and optimized for performance.',
    imgUrl: '/images/creative-agency/service_8.jpeg',
    href: '/service/service-details',
  },
  {
    title: 'AI/ML & Data Engineering',
    subtitle:
      'Harness the power of artificial intelligence and machine learning. We build intelligent systems, data pipelines, analytics solutions, and decision-support tools that drive business value.',
    imgUrl: '/images/creative-agency/service_9.jpeg',
    href: '/service/service-details',
  },
  {
    title: 'Technology Consulting',
    subtitle:
      'Strategic technology guidance, product strategy, architecture design, and digital transformation. Our consultants help you make informed technology decisions aligned with your business goals.',
    imgUrl: '/images/creative-agency/service_10.jpeg',
    href: '/service/service-details',
  },
];
const portfolioData = [
  {
    href: '/portfolio/portfolio-details',
    imgUrl: '/images/creative-agency/portfolio_1.jpeg',
    title: 'Awesome colorful artwork',
    btnText: 'See Project',
  },
  {
    href: '/portfolio/portfolio-details',
    imgUrl: '/images/creative-agency/portfolio_2.jpeg',
    title: 'Admin dashboard UI design',
    btnText: 'See Project',
  },
  {
    href: '/portfolio/portfolio-details',
    imgUrl: '/images/creative-agency/portfolio_3.jpeg',
    title: 'Product designing with brand',
    btnText: 'See Project',
  },
  {
    href: '/portfolio/portfolio-details',
    imgUrl: '/images/creative-agency/portfolio_4.jpeg',
    title: 'Kids education website design',
    btnText: 'See Project',
  },
];
const awardData = [
  {
    brand: 'Behance',
    title: 'UI/UX design of the month',
    subTitle:
      'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
    date: 'December 12, 2023',
    awardImgUrl: '/images/creative-agency/award_img_1.svg',
  },
  {
    brand: 'Awwwards',
    title: 'CSS awards design',
    subTitle:
      'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
    date: 'January 05, 2022',
    awardImgUrl: '/images/creative-agency/award_img_2.svg',
  },
  {
    brand: 'Google',
    title: 'Website of the day',
    subTitle:
      'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
    date: 'March 20, 2021',
    awardImgUrl: '/images/creative-agency/award_img_3.svg',
  },
];
const testimonialData = [
  {
    text: 'The team delivered an exceptional cloud migration solution that exceeded our expectations. Their technical expertise and systematic approach made the entire process smooth and efficient. Highly recommended for complex technology projects.',
    avatarName: 'Sarah Chen',
    avatarDesignation: 'CTO at FinTech Startup',
  },
  {
    text: 'Outstanding work on our mobile application development. The attention to detail, code quality, and user experience design were top-notch. They truly understand modern software development practices.',
    avatarName: 'Michael Adeyemi',
    avatarDesignation: 'Product Manager',
  },
  {
    text: 'Their AI/ML implementation transformed our data analytics capabilities. The team brought deep technical knowledge and delivered a solution that provides real business value. Great partnership.',
    avatarName: 'Dr. Amara Okonkwo',
    avatarDesignation: 'Director of Technology',
  },
];
const faqData = [
  {
    title: '01. What services does SAW Technologies provide?',
    content:
      'SAW Technologies offers comprehensive technology solutions including custom software development (web, mobile, cloud), AI/ML and data engineering, cloud infrastructure and DevOps services, technology consulting, systems integration, SaaS product development, and managed services. We specialize in building scalable, secure solutions that deliver measurable business value.',
  },
  {
    title: '02. How can I get started with a project?',
    content:
      'Getting started is simple. You can contact us through our website contact form, email us directly at info@sawtechnologies.com, or call us. We\'ll schedule an initial consultation to understand your requirements, discuss your goals, and provide a tailored solution proposal with timeline and cost estimates.',
  },
  {
    title: '03. What is your development process?',
    content:
      'Our development process follows industry best practices: Discovery & Requirements Gathering → Architecture Design & Planning → Iterative Development with Regular Reviews → Quality Assurance & Testing → Deployment & Integration → Training & Documentation → Ongoing Support & Maintenance. We use agile methodologies to ensure flexibility and continuous client involvement.',
  },
  {
    title: '04. Do you provide support after project completion?',
    content:
      'Yes, we provide comprehensive post-launch support including maintenance, updates, bug fixes, performance monitoring, security patches, and feature enhancements. We offer flexible support packages tailored to your needs, from basic maintenance to full managed services with 24/7 monitoring and support.',
  },
  {
    title: '05. What technologies do you work with?',
    content:
      'We work with modern, industry-standard technologies including React, Node.js, Python, Java, cloud platforms (AWS, Azure, Google Cloud), containerization (Docker, Kubernetes), databases (SQL and NoSQL), AI/ML frameworks (TensorFlow, PyTorch), and mobile development (React Native, Flutter). We select the best technology stack based on your specific project requirements.',
  },
];

const postData = [
  {
    thumbnailSrc: '/images/creative-agency/post_1.jpeg',
    title: 'Building Scalable Cloud Infrastructure: Best Practices for 2024',
    date: '07 Mar 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_2.jpeg',
    title: 'AI/ML Integration: Transforming Business Operations',
    date: '22 Apr 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_3.jpeg',
    title: 'Microservices Architecture: When and Why to Adopt',
    date: '13 May 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_4.jpeg',
    title: 'DevOps Best Practices for Modern Software Development',
    date: '15 Jun 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_1.jpeg',
    title: 'Securing Your SaaS Platform: Essential Security Measures',
    date: '10 Jul 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_2.jpeg',
    title: 'Data Engineering Fundamentals: Building Robust Pipelines',
    date: '22 Aug 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_3.jpeg',
    title: 'Custom Software vs. Off-the-Shelf: Making the Right Choice',
    date: '13 Sep 2024',
    url: '/blog/blog-details',
  },
  {
    thumbnailSrc: '/images/creative-agency/post_4.jpeg',
    title: 'Mobile App Development Trends for Enterprise Solutions',
    date: '15 Oct 2024',
    url: '/blog/blog-details',
  },
];

export default function Home() {
  pageTitle('SAW Technologies');
  return (
    <>
      <Hero
        title={[
          'Nigeria-Based Technology Solutions Provider',
          'Custom Software & Cloud Solutions',
          'AI/ML & Data Engineering Experts',
          'Enterprise-Grade Development',
        ]}
        subtitle="We Build Tech That Moves the Needle.
Future-ready software, data, and AI that deliver measurable business results."
        videoSrc="https://www.youtube.com/embed/VcaAVWtP48A"
        bgUrl="/images/creative-agency/hero_video_bg_1.jpeg"
      />
      <Spacing lg="125" md="70" />
      <div className="container">
        <FunFact data={funfactData} />
      </div>
      <Spacing lg="125" md="70" />
      <About
        thumbnail="/images/creative-agency/about_1.jpeg"
        uperTitle="Who We Are"
        title="Full-stack Technology Solutions Provider"
        subTitle="SAW Technologies specializes in building innovative software solutions that drive business growth. We combine deep technical expertise with modern development practices to deliver web, mobile, and cloud applications that solve real-world challenges and create measurable value for our clients."
        featureList={[
          'Cloud-native architecture & DevOps',
          'AI/ML powered intelligent systems',
          'Enterprise-grade security & scalability',
        ]}
        btnText="Learn More"
        btnUrl="/about"
      />
      <Spacing lg="125" md="70" />
      {/* Vision and Mission Section */}
      <section className="cs_gradient_bg_1">
        <Spacing lg="143" md="75" />
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              <div className="cs_section_heading cs_style_1">
                <p className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0">
                  Our Purpose
                </p>
                <Spacing lg="10" md="5" />
                <h2 className="cs_section_title cs_fs_50 mb-0">Vision</h2>
                <Spacing lg="25" md="15" />
                <p className="mb-0">
                  To be the trusted global partner for future-ready technology where foresight,
                  craftsmanship, and measurable outcomes turn complex challenges into simple,
                  human-centered solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_section_heading cs_style_1">
                <p className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0">
                  What We Do
                </p>
                <Spacing lg="10" md="5" />
                <h2 className="cs_section_title cs_fs_50 mb-0">Mission</h2>
                <Spacing lg="25" md="15" />
                <p className="mb-0">
                  We research, design, build, and scale innovative digital systems — web, mobile,
                  cloud, data, and AI — that deliver clear user and business value. We do this by
                  combining strategic consulting, thoughtful product design, world-class engineering,
                  and reliable operations to create secure, integrated, and sustainable solutions
                  for our clients and users.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="143" md="75" />
      </section>
      <Spacing lg="125" md="70" />
      <WhyChose
        sectionTitle="We have depth of market knowledge"
        sectionSubTitle="Why Choose Us"
        whyChoseFeatureData={whyChoseFeatureData}
        thumbnailSrc="/images/creative-agency/why_choose_us_img_3.jpeg"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Our core services"
            subTitle="Services"
            variantColor="cs_white_color"
          />
          <Spacing lg="45" md="30" />
        </div>
        <div className="container">
          <Service
            sectionTitle="Our core services"
            sectionSubTitle="Services"
            data={serviceListData}
          />
          <Spacing lg="135" md="65" />
        </div>
      </section>
      {/* Portfolio Section - Hidden */}
      {/* <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Some featured work" subTitle="Portfolio" />
          <Spacing lg="85" md="45" />
          <Portfolio data={portfolioData} />
          <Spacing lg="26" md="30" />
          <div className="text-center">
            <Button btnText="See All Project" btnUrl="/portfolio" />
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section> */}
      {/* Awards Section - Hidden */}
      {/* <section className="cs_primary_bg cs_shape_animation_2">
        <Spacing lg="143" md="75" />
        <div className="cs_shape_1 position-absolute">
          <svg
            width={65}
            height={64}
            viewBox="0 0 65 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.5">
              <path
                d="M62.4554 25.9314C55.6838 19.6081 40.1618 12.4752 32.1637 20.1537C41.7609 21.9206 53.2379 29.2392 48.3751 39.1677C45.1712 45.7019 38.7353 45.7177 33.3337 41.995C27.338 37.8739 25.7108 31.2667 27.4596 24.5962C26.5312 24.5866 25.6039 24.6605 24.6889 24.8172C9.80991 27.7447 14.0713 47.6353 20.9187 55.948C22.4528 57.8045 19.7488 60.3159 18.1393 58.4837C7.86403 46.8126 6.49349 23.0691 25.5532 19.9295C26.8892 19.7254 28.2446 19.6801 29.5912 19.7945C36.9845 9.42053 56.5698 17.4866 64.055 24.4366C65.1096 25.4175 63.4831 26.8926 62.4554 25.9314ZM33.9938 39.0327C38.3927 42.4636 44.2429 40.8527 44.3919 34.8698C44.6036 28.2263 35.7464 25.0921 29.1457 24.655C27.1454 29.9313 29.4427 35.4836 33.9938 39.0327Z"
                fill="#4F4747"
              />
            </g>
          </svg>
        </div>
        <div className="container">
          <SectionHeading
            title="Our prize achievement"
            subTitle="Awards"
            variantColor="cs_white_color"
          />
          <Spacing lg="85" md="45" />
          <Award data={awardData} />
        </div>
        <Spacing lg="150" md="80" />
      </section> */}
      <TestimonialSlider
        layeredImages={[
          '/images/creative-agency/layer_img_1.jpeg',
          '/images/creative-agency/layer_img_2.jpeg',
          '/images/creative-agency/layer_img_3.jpeg',
          '/images/creative-agency/layer_img_4.jpeg',
          '/images/creative-agency/layer_img_5.jpeg',
        ]}
        data={testimonialData}
      />
      <section>
        <div className="container">
          <Cta
            title="Is there a specific project or goal that you have in mind?"
            btnText="Contact Us"
            btnUrl="/contact"
            bgUrl="/images/creative-agency/cta_bg.jpeg"
          />
        </div>
      </section>
      <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Some recent news" subTitle="Our Blog" />
          <Spacing lg="85" md="45" />
        </div>
        <PostCarousel data={postData} />
      </section>
      <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Frequently asked question" subTitle="FAQs" />
          <Spacing lg="55" md="30" />
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <Accordion variant="cs_type_1" data={faqData} />
            </div>
          </div>
        </div>
        <Spacing lg="120" md="50" />
      </section>
    </>
  );
}
